export const ServerGroupTemplates = {
  userData: require('../details/userData.html'),
};
